const navigation = [
  {
    url: "/guiding-principles",
    text: "Guiding Principles",
  },
]

export default navigation
